module.exports = __webpack_public_path__ + "static/media/you-died.0d68fdae.mp3";